import { render, staticRenderFns } from "./EImzaServisIndir.vue?vue&type=template&id=6e6c69cd&scoped=true"
import script from "./EImzaServisIndir.vue?vue&type=script&lang=ts"
export * from "./EImzaServisIndir.vue?vue&type=script&lang=ts"
import style0 from "./EImzaServisIndir.vue?vue&type=style&index=0&id=6e6c69cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c69cd",
  null
  
)

export default component.exports